import { render } from "./InvestigationAddModal.vue?vue&type=template&id=5a1dd6ee&scoped=true"
import script from "./InvestigationAddModal.vue?vue&type=script&lang=js"
export * from "./InvestigationAddModal.vue?vue&type=script&lang=js"

import "./InvestigationAddModal.vue?vue&type=style&index=0&id=5a1dd6ee&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a1dd6ee"]])

export default __exports__